import Link from 'next/link';
import { useRef } from 'react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import MetaSeo from '../MetaSeo';
import Slider from 'react-slick';
import useTrans from '../../hooks/useTrans';
import { getAllServices } from '../../redux/actions/services';
export default function Sdk(props) {
  const [service, setService] = useState([]);
  const trans = useTrans();
  const slider = useRef();
  const [value_select, setValueSelect] = useState('vi');
  const router = useRouter();
  const dispatch = useDispatch();
  // useEffect(() => {
  //     getListServiceAll();
  //     setValueSelect(router.locale);
  // }, router.locale);

  // const getListServiceAll = async () => {
  //     const data = await getAllServices({}, dispatch);
  //     if (data) {
  //         setService(data?.rows);
  //     }
  // };
  const settings = {
    dots: true,
    speed: 300,
    // vertical: false,
    // autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: (
      <button
        className="slick-prev slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    nextArrow: (
      <button
        className="slick-next slick-arrow"
        aria-label="Next"
        type="button"
      >
        <img src="./assets/images/home/icon-next.svg" />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const dataSeo = {
    title: 'SDK | EYEFIRE',
    description: trans.seo.sdk.description
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="main-content">
        <section className="p-sdk">
          <div className="c-big-banner big-banner-sdk">
            <div className="c-big-banner__image">
              <img
                className="w-100 item-pc"
                src="/assets/img/sdk/img_big-banner.webp"
                alt=""
              />
              <img
                className="item-sp w-100"
                src="/assets/img/sdk/img_big-banner-sp.webp"
                alt=""
              />
            </div>
            <div className="c-big-banner__inner">
              <div className="l-container">
                <div className="p-sdk__big-banner__content">
                  <p className="p-sdk__big-banner__content-desc">
                    {trans.sdk.slogan_sdk}
                  </p>
                  <h3 className="p-sdk__big-banner__content-title">
                    {trans.sdk.title_sdk}
                  </h3>
                  <p className="p-sdk__big-banner__content-slogan">
                    {trans.sdk.content_sdk1}
                  </p>
                  <div className="p-sdk__big-banner__content-handle">
                    <a href="#" className="c-btn">
                      {trans.sdk.button_try}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-sdk__main">
            <div className="p-sdk__eyefire">
              <div className="l-container-fluid">
                <div className="p-sdk__eyefire__img-bg">
                  <img
                    className="w-100 item-pc"
                    src="./assets/img/sdk/bg_eyefire.webp"
                    alt=""
                  />
                  <div className="p-sdk__eyefire__inner">
                    <div className="c-title c-title--center">
                      <h3>{trans.sdk.title_big_box}</h3>
                      <p className="p-sdk__eyefire__inner-p">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: trans.sdk.content_big_box,
                          }}
                        ></div>
                      </p>
                    </div>
                    <div className="p-sdk__eyefire__content">
                      <div className="p-sdk__eyefire__content-image item-sp">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/bg_eyefire-sp.png"
                          alt=""
                        />
                      </div>
                      <ul>
                        <li>
                          <div className="p-sdk__eyefire__content__box">
                            <div className="p-sdk__eyefire__content__box-image">
                              <img
                                className="w-100"
                                src="./assets/img/sdk/icn_ios.svg"
                                alt=""
                              />
                            </div>
                            <div className="p-sdk__eyefire__content__box-desc">
                              <h4>{trans.sdk.sdk1}</h4>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="p-sdk__eyefire__content__box">
                            <div className="p-sdk__eyefire__content__box-image">
                              <img
                                className="w-100"
                                src="./assets/img/sdk/icn_android.svg"
                                alt=""
                              />
                            </div>
                            <div className="p-sdk__eyefire__content__box-desc">
                              <h4>{trans.sdk.sdk2}</h4>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="p-sdk__eyefire__content__box">
                            <div className="p-sdk__eyefire__content__box-image">
                              <img
                                className="w-100"
                                src="./assets/img/sdk/icn_server.svg"
                                alt=""
                              />
                            </div>
                            <div className="p-sdk__eyefire__content__box-desc">
                              <h4>{trans.sdk.sdk3}</h4>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-sdk__face">
              <div className="l-container">
                <div className="c-title c-title--center">
                  <h3 data-aos="fade-up">{trans.sdk.face_title}</h3>
                  <p>{trans.sdk.face_content}</p>
                </div>
                <div className="p-sdk__face__content">
                  <div
                    className="p-sdk__face__content__inner"
                    data-aos="fade-up"
                  >
                    <img
                      className="w-100 item-pc"
                      src="./assets/img/sdk/bg_box_face.webp"
                      alt=""
                    />
                    <img
                      className="w-100 item-sp"
                      src="./assets/img/sdk/bg_box_face-sp.webp"
                      alt=""
                    />
                    <div className="p-sdk__face__content__box">
                      <div className="p-sdk__face__content__box-icon">
                        <img
                          className="item-pc"
                          src="./assets/img/sdk/icn_box_face_01.svg"
                          alt=""
                        />
                        <img
                          className="item-sp"
                          src="./assets/img/sdk/icn_box_face_01-sp.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__face__content__box-title">
                        <h3>{trans.sdk.title_box1}</h3>
                      </div>
                      <div className="p-sdk__face__content__box-desc">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: trans.sdk.content_box1,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-sdk__face__content__inner"
                    data-aos="fade-up"
                  >
                    <img
                      className="w-100 item-pc"
                      src="./assets/img/sdk/bg_box_face.webp"
                      alt=""
                    />
                    <img
                      className="w-100 item-sp"
                      src="./assets/img/sdk/bg_box_face-sp.webp"
                      alt=""
                    />
                    <div className="p-sdk__face__content__box">
                      <div className="p-sdk__face__content__box-icon p-sdk__face-pos">
                        <img
                          className="item-pc"
                          src="./assets/img/sdk/icn_box_face_02.svg"
                          alt=""
                        />
                        <img
                          className="item-sp"
                          src="./assets/img/sdk/icn_box_face_02-sp.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__face__content__box-title">
                        <h3>{trans.sdk.title_box2}</h3>
                      </div>
                      <div className="p-sdk__face__content__box-desc">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: trans.sdk.content_box2,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-sdk__face__content__inner"
                    data-aos="fade-up"
                  >
                    <img
                      className="w-100 item-pc"
                      src="./assets/img/sdk/bg_box_face.webp"
                      alt=""
                    />
                    <img
                      className="w-100 item-sp"
                      src="./assets/img/sdk/bg_box_face-sp.webp"
                      alt=""
                    />
                    <div className="p-sdk__face__content__box">
                      <div className="p-sdk__face__content__box-icon p-sdk__face-pos">
                        <img
                          className="item-pc"
                          src="./assets/img/sdk/icn_box_face_03.svg"
                          alt=""
                        />
                        <img
                          className="item-sp"
                          src="./assets/img/sdk/icn_box_face_03-sp.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__face__content__box-title">
                        <h3>{trans.sdk.title_box3}</h3>
                      </div>
                      <div className="p-sdk__face__content__box-desc">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: trans.sdk.content_box3,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-sdk__face__content__inner"
                    data-aos="fade-up"
                  >
                    <img
                      className="w-100 item-pc"
                      src="./assets/img/sdk/bg_box_face.webp"
                      alt=""
                    />
                    <img
                      className="w-100 item-sp"
                      src="./assets/img/sdk/bg_box_face-sp.webp"
                      alt=""
                    />
                    <div className="p-sdk__face__content__box">
                      <div className="p-sdk__face__content__box-icon">
                        <img
                          className="item-pc"
                          src="./assets/img/sdk/icn_box_face_04.svg"
                          alt=""
                        />
                        <img
                          className="item-sp"
                          src="./assets/img/sdk/icn_box_face_04-sp.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__face__content__box-title">
                        <h3>{trans.sdk.title_box4}</h3>
                      </div>
                      <div className="p-sdk__face__content__box-desc">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: trans.sdk.content_box4,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-sdk__face__content__inner"
                    data-aos="fade-up"
                  >
                    <img
                      className="w-100 item-pc"
                      src="./assets/img/sdk/bg_box_face.webp"
                      alt=""
                    />
                    <img
                      className="w-100 item-sp"
                      src="./assets/img/sdk/bg_box_face-sp.webp"
                      alt=""
                    />
                    <div className="p-sdk__face__content__box">
                      <div className="p-sdk__face__content__box-icon">
                        <img
                          className="item-pc"
                          src="./assets/img/sdk/icn_box_face_05.svg"
                          alt=""
                        />
                        <img
                          className="item-sp"
                          src="./assets/img/sdk/icn_box_face_05-sp.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__face__content__box-title">
                        <h3>{trans.sdk.title_box5}</h3>
                      </div>
                      <div className="p-sdk__face__content__box-desc">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: trans.sdk.content_box5,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-sdk__option">
              <div className="l-container-fluid">
                <div className="c-title c-title--center">
                  <h3 data-aos="fade-up">{trans.sdk.feature_sdk_title}</h3>
                  <p>{trans.sdk.feature_sdk_content}</p>
                </div>
                <div className="p-sdk__option__inner">
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_01.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_01.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft1}</h3>
                        <p>{trans.sdk.content_ft1}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_02.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_02.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft2}</h3>
                        <p>{trans.sdk.content_ft2}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_03.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_03.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft3}</h3>
                        <p>{trans.sdk.content_ft3}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-sdk__option__inner p-sdk__option__inner--slider content-web">
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_01.png"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_01.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft1}</h3>
                        <p>{trans.sdk.content_ft1}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_02.png"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_02.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft2}</h3>
                        <p>{trans.sdk.content_ft2}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__option__box">
                    <div className="p-sdk__option__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_option_03.png"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__option__box__content">
                      <div className="p-sdk__option__box__content-icon">
                        <img
                          className="w-100"
                          src="./assets/img/sdk/icn_option_03.svg"
                          alt=""
                        />
                      </div>
                      <div className="p-sdk__option__box__content-desc">
                        <h3>{trans.sdk.title_ft3}</h3>
                        <p>{trans.sdk.content_ft3}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container-custom content-mobile">
                  <div className="news-slider">
                    <Slider ref={slider} {...settings}>
                      {/* <div className='p-sdk__option__inner p-sdk__option__inner--slider'> */}
                      <div className="p-sdk__option__box">
                        <div className="p-sdk__option__box__image">
                          <img
                            className="w-100"
                            src="./assets/img/sdk/img_option_01.png"
                            alt=""
                          />
                        </div>
                        <div className="p-sdk__option__box__content">
                          <div className="p-sdk__option__box__content-icon">
                            <img
                              className="w-100"
                              src="./assets/img/sdk/icn_option_01.svg"
                              alt=""
                            />
                          </div>
                          <div className="p-sdk__option__box__content-desc">
                            <h3>{trans.sdk.title_ft1}</h3>
                            <p>{trans.sdk.content_ft1}</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-sdk__option__box">
                        <div className="p-sdk__option__box__image">
                          <img
                            className="w-100"
                            src="./assets/img/sdk/img_option_02.png"
                            alt=""
                          />
                        </div>
                        <div className="p-sdk__option__box__content">
                          <div className="p-sdk__option__box__content-icon">
                            <img
                              className="w-100"
                              src="./assets/img/sdk/icn_option_02.svg"
                              alt=""
                            />
                          </div>
                          <div className="p-sdk__option__box__content-desc">
                            <h3>{trans.sdk.title_ft2}</h3>
                            <p>{trans.sdk.content_ft2}</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-sdk__option__box">
                        <div className="p-sdk__option__box__image">
                          <img
                            className="w-100"
                            src="./assets/img/sdk/img_option_03.png"
                            alt=""
                          />
                        </div>
                        <div className="p-sdk__option__box__content">
                          <div className="p-sdk__option__box__content-icon">
                            <img
                              className="w-100"
                              src="./assets/img/sdk/icn_option_03.svg"
                              alt=""
                            />
                          </div>
                          <div className="p-sdk__option__box__content-desc">
                            <h3>{trans.sdk.title_ft3}</h3>
                            <p>{trans.sdk.content_ft3}</p>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-sdk__advantages">
              <div className="l-container">
                <div className="c-title c-title--center">
                  <h3 data-aos="fade-up">{trans.sdk.feature_title}</h3>
                </div>
                <div className="p-sdk__advantages__inner">
                  {' '}
                  <br className="item-pc" />
                  <div className="p-sdk__advantages__box" data-aos="fade-right">
                    <div className="p-sdk__advantages__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_advantages_01.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__advantages__box__content">
                      <div className="p-sdk__advantages__box__content-title">
                        <h3>{trans.sdk.tec_box_1}</h3>
                      </div>
                      <div className="p-sdk__advantages__box__content-desc">
                        <p>{trans.sdk.tec_content_box1}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__advantages__box" data-aos="fade-left">
                    <div className="p-sdk__advantages__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_advantages_02.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__advantages__box__content">
                      <div className="p-sdk__advantages__box__content-title">
                        <h3>{trans.sdk.tec_box_2}</h3>
                      </div>
                      <div className="p-sdk__advantages__box__content-desc">
                        <p>{trans.sdk.tec_content_box2}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__advantages__box" data-aos="fade-right">
                    <div className="p-sdk__advantages__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_advantages_03.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__advantages__box__content">
                      <div className="p-sdk__advantages__box__content-title">
                        <h3>{trans.sdk.tec_box_3}</h3>
                      </div>
                      <div className="p-sdk__advantages__box__content-desc">
                        <p>{trans.sdk.tec_content_box3}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-sdk__advantages__box" data-aos="fade-left">
                    <div className="p-sdk__advantages__box__image">
                      <img
                        className="w-100"
                        src="./assets/img/sdk/img_advantages_04.webp"
                        alt=""
                      />
                    </div>
                    <div className="p-sdk__advantages__box__content">
                      <div className="p-sdk__advantages__box__content-title">
                        <h3>{trans.sdk.tec_box_4}</h3>
                      </div>
                      <div className="p-sdk__advantages__box__content-desc">
                        <p>{trans.sdk.tec_content_box4}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
